import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { MapPin, ArrowRight } from "react-feather";
import EmptyState from "../../../common/EmptyState";
import "./agentDatatable.css";

const getInitials = (name) => {
  if (!name) return "?";
  const parts = name.trim().split(" ").filter(Boolean);
  if (parts.length > 1) {
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  }
  return parts.length ? parts[0].slice(0, 2).toUpperCase() : "?";
};

const formatBalance = (value) =>
  value ? parseFloat(value).toFixed(2) : "0.00";

const TONES = ["sky", "mint", "butter", "peach", "lilac"];
const toneFor = (name) => {
  const s = String(name || "?");
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return TONES[h % TONES.length];
};

// Order agents as wallets: who they are, and the Rupee / RMB fund they hold.
export class Datatable extends Component {
  goToAgent = (name) => {
    this.props.history.push(`/business-consultancy/sourcing/agents/${name}`);
  };

  render() {
    const { myData } = this.props;

    if (!myData || myData.length === 0) {
      return <EmptyState>No agents found.</EmptyState>;
    }

    return (
      <Fragment>
        <ul className="kd-agents">
          {myData.map((employee, index) => (
            <li
              key={employee.employeeId || index}
              className={`kd-agent kd-st--${toneFor(employee.name)}`}
              style={{ "--i": Math.min(index, 12) }}
            >
              <button
                type="button"
                className="kd-agent-card"
                onClick={() => this.goToAgent(employee.name)}
                aria-label={`Open ${employee.name}'s months`}
              >
                <span className="kd-agent-top">
                  <span className="kd-agent-avatar" aria-hidden="true">
                    {getInitials(employee.name)}
                  </span>
                  <span className="kd-agent-who">
                    <span className="kd-agent-name">{employee.name}</span>
                    <span className="kd-agent-role">{employee.designation || "Agent"}</span>
                  </span>
                  <span className="kd-agent-go" aria-hidden="true">
                    <ArrowRight size={16} />
                  </span>
                </span>
                {employee.address && (
                  <span className="kd-agent-address">
                    <MapPin size={12} aria-hidden="true" />
                    {employee.address}
                  </span>
                )}
                <span className="kd-agent-pockets">
                  <span className={"kd-agent-pocket" + (employee.rupeeBalance > 0 ? " is-full" : "")}>
                    <span className="kd-agent-pocket-label">Rupee balance</span>
                    <span className="kd-agent-pocket-value">
                      <span aria-hidden="true">₹</span> {formatBalance(employee.rupeeBalance)}
                    </span>
                  </span>
                  <span className={"kd-agent-pocket" + (employee.rmbBalance > 0 ? " is-full" : "")}>
                    <span className="kd-agent-pocket-label">RMB balance</span>
                    <span className="kd-agent-pocket-value">
                      <span aria-hidden="true">¥</span> {formatBalance(employee.rmbBalance)}
                    </span>
                  </span>
                </span>
              </button>
            </li>
          ))}
        </ul>
      </Fragment>
    );
  }
}

export default connect(null, {})(Datatable);
